module.exports = __webpack_public_path__ + "media/home/Press-3-ab9f6d18.png";